<div class="h-full bg-gradient-to-t from-white via-white to-primary-200">
	<router-outlet></router-outlet>
</div>
